export const COACH_FUNCTION_OPTIONS = [
  { label: 'Product', slug: 'product' },
  { label: 'Ops & Strat', slug: 'ops_strat' },
  { label: 'People Ops', slug: 'people_ops' },
  { label: 'Sales', slug: 'sales' },
  { label: 'Data Science', slug: 'data_science' },
  { label: 'Engineering', slug: 'engineering' },
  { label: 'Marketing & Communications', slug: 'marketing' },
  { label: 'Customer Success', slug: 'customer_success' },
  { label: 'Design', slug: 'design' },
  { label: 'Finance', slug: 'finance' },
  { label: 'Legal', slug: 'legal' },
  { label: 'Research', slug: 'research' },
  { label: 'Trust & Safety', slug: 'trust_safety' },
  {
    label: 'IT / Enterprise Technology',
    slug: 'it_enterprise_technology',
  },
] as const;

export const COACH_FUNCTION_SLUGS: ReadonlySet<string> = new Set(
  COACH_FUNCTION_OPTIONS.map(({ slug }) => slug),
);

const COACH_FUNCTION_LABEL_BY_SLUG = Object.fromEntries(
  COACH_FUNCTION_OPTIONS.map(({ label, slug }) => [slug, label]),
) as Record<string, string>;

export const isCoachFunctionSlug = (slug: string): boolean =>
  COACH_FUNCTION_SLUGS.has(slug);

export const coachFunctionLabel = (slug: string): string =>
  COACH_FUNCTION_LABEL_BY_SLUG[slug] ??
  slug
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
